import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '吃瓜导航',
    links: [
      { label: '热门大瓜', href: '/category/remen-dagua' },
      { label: '黑料曝光', href: '/category/expose' },
      { label: '吃瓜大赛', href: '/category/competition' },
      { label: '吃瓜事件', href: '/category/event' },
    ],
  },
  {
    title: '51在线',
    links: [
      { label: '51吃瓜入口', href: '/category/51online' },
      { label: '今日吃瓜合集', href: '/category/51online' },
      { label: '吃瓜爆料投稿', href: '/about' },
      { label: '实时更新', href: '/' },
    ],
  },
  {
    title: '关于',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '口碑评价', href: '/about' },
      { label: '联系方式', href: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/70">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
              {/* Brand Column */}
              <div className="md:col-span-4 flex flex-col items-start">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                    <i className="ri-fire-line text-background-50 text-xl"></i>
                  </div>
                  <span className="text-xl font-heading font-bold text-foreground-900">
                    今日吃瓜
                  </span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed max-w-xs">
                  全网热门事件一站式聚合平台。实时更新最新吃瓜动态，独家黑料曝光，每日吃瓜大赛，51在线入口。做最懂你的吃瓜助手。
                </p>
              </div>

              {/* Link Columns */}
              {footerLinks.map((col) => (
                <div key={col.title} className="md:col-span-2">
                  <h3 className="text-xs font-bold text-foreground-400 uppercase tracking-wider mb-4">
                    {col.title}
                  </h3>
                  <ul className="space-y-3">
                    {col.links.map((link) => (
                      <li key={link.label}>
                        <Link
                          to={link.href}
                          className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}

              {/* Social Column */}
              <div className="md:col-span-2">
                <h3 className="text-xs font-bold text-foreground-400 uppercase tracking-wider mb-4">
                  关注我们
                </h3>
                <div className="flex items-center gap-3">
                  <a
                    href="#"
                    className="w-9 h-9 rounded-lg bg-foreground-900 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    <i className="ri-weibo-line text-background-50 text-base"></i>
                  </a>
                  <a
                    href="#"
                    className="w-9 h-9 rounded-lg bg-foreground-900 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    <i className="ri-wechat-line text-background-50 text-base"></i>
                  </a>
                  <a
                    href="#"
                    className="w-9 h-9 rounded-lg bg-foreground-900 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    <i className="ri-vidicon-line text-background-50 text-base"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Bottom Bar */}
            <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400">
                &copy; 2026 今日吃瓜 mxrxlb125.cn 版权所有
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <a href="#" className="hover:text-foreground-600 transition-colors cursor-pointer">
                  隐私政策
                </a>
                <span className="text-foreground-300">|</span>
                <a href="#" className="hover:text-foreground-600 transition-colors cursor-pointer">
                  用户协议
                </a>
                <span className="text-foreground-300">|</span>
                <a href="#" className="hover:text-foreground-600 transition-colors cursor-pointer">
                  免责声明
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
